/**
 * useDescription hook.
 */
import MainContext from '@shared/components/utils/context/mainContext';
import useMetadata from '@shared/components/utils/hooks/useMetadata';
import { DescriptionContextProps } from '@shared/components/utils/context/descriptionContext';
import { setDescription } from '@shared/store/slices/app.slice';
import { useAppDispatch } from '@shared/store/hooks';
import { useContext, useEffect } from 'react';

/**
 * Hook to set the description of the currently focused asset in a rail.
 */
export default function useDescription(): DescriptionContextProps {
  // Dispatch
  const dispatch = useAppDispatch();

  // Context
  const { asset, display } = useContext(MainContext);

  // Effects
  useEffect(() => {
    dispatch(setDescription(display?.description || false));
  }, [display]);

  useEffect(() => {
    return () => {
      dispatch(setDescription(false));
    };
  }, []);

  // Metadata
  const metadata = useMetadata({ asset });

  // Return values
  return {
    asset: asset ?? null,
    display: display?.description ?? false,
    metadata,
  };
}
